import { render, staticRenderFns } from "./jinrjq_config.vue?vue&type=template&id=6b33114a&scoped=true"
import script from "./jinrjq_config.vue?vue&type=script&lang=js"
export * from "./jinrjq_config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b33114a",
  null
  
)

export default component.exports